/* record.js · Munique Home · Record-a-Message page
 * Gallery (scroll-snap + thumbs), bundle tiers (variants as radios), add to cart -> checkout,
 * "See it in action" inline videos, lazy autoplay clips, testimonial slider. */
(function () {
  'use strict';
  function config() { try { return JSON.parse(document.querySelector('[data-rc-config]').textContent); } catch (e) { return {}; } }

  function initGallery(root) {
    var stage = root.querySelector('[data-rc-stage]');
    var slides = stage ? [].slice.call(stage.querySelectorAll('[data-rc-slide]')) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-rc-thumb]'));
    if (!stage || !slides.length) return;
    var active = -1;
    function setActive(i) {
      if (i === active) return; active = i;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var t = thumbs[i]; if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: 'smooth' }); setActive(i); }); });
    var ticking = false;
    stage.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var x = stage.scrollLeft, best = 0, bd = Infinity;
        slides.forEach(function (s, i) { var d = Math.abs((s.offsetLeft - stage.offsetLeft) - x); if (d < bd) { bd = d; best = i; } });
        setActive(best);
      });
    });
    setActive(0);
  }

  function initTiers(root) {
    var tiers = [].slice.call(root.querySelectorAll('[data-rc-tier]'));
    function sync() { tiers.forEach(function (t) { var r = t.querySelector('input'); var on = !!(r && r.checked); t.classList.toggle('is-sel', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
    tiers.forEach(function (t) { var r = t.querySelector('input'); if (r) r.addEventListener('change', sync); });
    sync();
  }

  function initBuy(root) {
    var form = root.querySelector('[data-rc-form]'); if (!form) return;
    var btn = form.querySelector('[data-rc-buy]'); var status = form.querySelector('[data-rc-status]');
    var cfg = config(); var busy = false;
    function show(msg) { if (!status) return; status.textContent = msg || ''; status.hidden = !msg; }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (busy) return;
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) { show('Please choose a bundle.'); return; }
      busy = true; show(''); if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      fetch(cfg.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }] }) })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (o) {
          if (!o.ok || o.d.status) { show((o.d && (o.d.description || o.d.message)) || 'Could not add to cart.'); return; }
          window.location.assign(cfg.checkoutUrl || '/checkout');
        })
        .catch(function () { show('Something went wrong. Please try again.'); })
        .finally(function () { busy = false; if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
    });
  }

  function initVideos(root) {
    // The four clips autoplay muted (loaded by initLazyClips); a tap toggles the sound.
    var cards = [].slice.call(root.querySelectorAll('[data-rc-video]'));
    cards.forEach(function (card) {
      var v = card.querySelector('video'); if (!v) return;
      card.addEventListener('click', function () {
        if (v.muted) {
          cards.forEach(function (o) { var ov = o.querySelector('video'); if (ov && ov !== v) { ov.muted = true; o.classList.remove('is-sound'); } });
          v.muted = false; card.classList.add('is-sound');
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.muted = true; card.classList.remove('is-sound'); }
      });
    });
  }

  function initClickVideos() {
    [].slice.call(document.querySelectorAll('[data-rc-click-video]')).forEach(function (box) {
      if (box.dataset.rcInit) return; box.dataset.rcInit = '1';
      var v = box.querySelector('video'); if (!v) return;
      box.addEventListener('click', function () {
        if (v.paused) { [].slice.call(document.querySelectorAll('video')).forEach(function (o) { if (o !== v && !o.muted) o.pause(); }); v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
      v.addEventListener('play', function () { box.classList.add('is-playing'); });
      v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
      v.addEventListener('ended', function () { box.classList.remove('is-playing'); v.currentTime = 0; });
    });
  }

  function initLazyClips() {
    var vids = [].slice.call(document.querySelectorAll('video[data-rc-lazy]'));
    function load(v) { if (v.dataset.loaded) return; v.dataset.loaded = '1'; var s = v.getAttribute('data-src'); if (s) v.src = s; v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } }); }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function initSliders() {
    [].slice.call(document.querySelectorAll('[data-rc-slider]')).forEach(function (s) {
      if (s.dataset.rcInit) return; s.dataset.rcInit = '1';
      var list = s.querySelector('[data-rc-slider-list]'); if (!list) return;
      var items = [].slice.call(list.children);
      var cur = s.querySelector('[data-rc-slider-current]'), prev = s.querySelector('[data-rc-slider-prev]'), next = s.querySelector('[data-rc-slider-next]');
      function index() { var x = list.scrollLeft, best = 0, bd = Infinity; items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - list.offsetLeft - x); if (d < bd) { bd = d; best = i; } }); return best; }
      function go(i) { i = Math.max(0, Math.min(items.length - 1, i)); list.scrollTo({ left: items[i].offsetLeft - list.offsetLeft, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      list.addEventListener('scroll', function () { if (cur) cur.textContent = String(index() + 1); });
    });
  }

  function init() {
    var root = document.querySelector('[data-rc-main]');
    if (root && !root.dataset.rcInit) { root.dataset.rcInit = '1'; initGallery(root); initTiers(root); initBuy(root); initVideos(root); }
    initLazyClips(); initSliders(); initClickVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
